<title>{{ functionalCapabilitiesDisruptionHandlingPage.htmlTitle }}</title>
<div *ngIf="isTab || isTabOverride" class="">
  <ul class="d-flex nav-bar">
    <li *ngFor="let tab of apiTabs; let i = index" class="tab-link bgdgry"
      [ngClass]="selectedIndex === i ? 'border-blue' : 'border-darkblack'" (click)="selectedIndex = i">
      <a class="nav-link active" data-bs-toggle="tab" (click)="setPageTitle(apiName + ' ' + tab)">
        <i [ngClass]="apiTabsClass[i]"></i>
        {{ tab }}</a>
    </li>
  </ul>
</div>
<!-- Tab panes -->
<div class="tab-content">
  <app-functional-capabilities-introduction-section
    [sections]="functionalCapabilitiesDisruptionHandlingPage.introductionSections">
  </app-functional-capabilities-introduction-section>
  <app-functional-capabilities-ribbon-tile-section [isRibbonTile]="true"
    *ngIf="group !== 'ribbon-tile-saw-tooth-vertical' && category !== 'purple-color-ribbon-tile'"
    [ribbonTileSections]="functionalCapabilitiesDisruptionHandlingPage.ribbonTileSections">
  </app-functional-capabilities-ribbon-tile-section>
  <app-functional-capabilities-ribbon-tile-section *ngIf="group === 'ribbon-tile-saw-tooth-vertical'"
    [isRibbonTileSawToothVertical]="true"
    [ribbonTileSections]="functionalCapabilitiesDisruptionHandlingPage.ribbonTileSections">
  </app-functional-capabilities-ribbon-tile-section>
  <app-functional-capabilities-disruption-handling-start-ribbon-tile-section
    [ribbonTileSections]="functionalCapabilitiesDisruptionHandlingPage.ribbonTileSections"
    *ngIf="category === 'purple-color-ribbon-tile'"></app-functional-capabilities-disruption-handling-start-ribbon-tile-section>
  <app-functional-capabilities-introduction-section
    [sections]="functionalCapabilitiesDisruptionHandlingPage.sectionBelowRibbonTile">
  </app-functional-capabilities-introduction-section>
</div>